(function(){const i='header a[href^="/cart"], [data-drawer-trigger="cart"]',r='button[name="add"], .product-form__submit, .add-to-cart, [data-add-to-cart], .cro-custom-btn';document.addEventListener("click",function(t){const n=t.target.closest(r);n&&n.classList.add("btn--loading")});function e(){setTimeout(()=>{const t=document.querySelector(i);t&&(document.body.classList.contains("js-drawer-open")||document.body.classList.contains("is-drawer-open")||t.click()),document.querySelectorAll(".btn--loading").forEach(n=>{n.classList.remove("btn--loading")})},1e3)}const s=window.fetch;window.fetch=function(){return s.apply(this,arguments).then(t=>{if(t.url&&(t.url.includes("/cart/add")||t.url.includes("/cart/add.js"))){if(t.url.includes("stealth=true"))return t;t.clone().json().then(c=>{(c.id||c.items)&&e()}).catch(()=>{})}return t})};const o=XMLHttpRequest.prototype.open,a=XMLHttpRequest.prototype.send;XMLHttpRequest.prototype.open=function(t,n){return this._url=n,o.apply(this,arguments)},XMLHttpRequest.prototype.send=function(){return this.addEventListener("load",function(){if(this._url&&(this._url.includes("/cart/add")||this._url.includes("/cart/add.js"))){if(this._url.includes("stealth=true"))return;this.status>=200&&this.status<300&&e()}}),a.apply(this,arguments)}})();

/* Quick shop drawer: prevent close-button click-through on touch.
   MicroModal (vendor.js) binds its close handler to BOTH "touchstart" and "click"
   and never calls preventDefault. On touch input, touchstart on the close X (or the
   backdrop) closes the drawer, whose panel reverts to content-visibility:hidden
   immediately, so the browser's synthesized click falls through to the product card
   beneath - opening/navigating it. We preventDefault the touchstart on the drawer's
   own close triggers, which suppresses that ghost click. The drawer still closes
   (MicroModal's own touchstart listener still runs). Desktop mouse never fires
   touchstart, so it is unaffected. Scoped to .quickview__modal close triggers only,
   so size selection and add-to-cart taps are untouched. */
(function () {
  document.addEventListener(
    "touchstart",
    function (e) {
      var trigger = e.target.closest ? e.target.closest("[data-micromodal-close]") : null;
      if (trigger && trigger.closest(".quickview__modal")) {
        e.preventDefault();
      }
    },
    { capture: true, passive: false }
  );
})();

/* Quick shop drawer image carousel: desktop prev/next arrows scroll the scroll-snap
   track by one viewport width. Mobile uses native swipe (no JS needed). Delegated so
   it works on the AJAX-injected drawer content. */
(function () {
  document.addEventListener("click", function (e) {
    var btn = e.target.closest ? e.target.closest("[data-qv-prev], [data-qv-next]") : null;
    if (!btn) return;
    var gallery = btn.closest("[data-qv-gallery]");
    var track = gallery && gallery.querySelector("[data-qv-track]");
    if (!track) return;
    var dir = btn.hasAttribute("data-qv-next") ? 1 : -1;
    track.scrollBy({ left: dir * track.clientWidth, behavior: "smooth" });
  });
})();

/* Quick shop drawer: always open with the size options EXPANDED, while keeping the
   show/hide options toggle working. The theme's toggleForm() collapses the options
   (removes .is-expanded from [data-quickview-form-area]) on open when the viewport
   leftover space is under ~250px - which is why the drawer sometimes opened with the
   sizes hidden. It does this in a deferred setTimeout after the modal shows. On open
   (theme:scroll:lock fires for the quick shop drawer), we re-assert .is-expanded for a
   short window via a scoped observer to win that race, then disconnect so the user can
   still collapse the options manually with the toggle. */
(function () {
  var userToggled = false;

  function syncAria(modal) {
    var area = modal.querySelector("[data-quickview-form-area]");
    var btn = modal.querySelector("[data-toggle-button]");
    if (!area || !btn) return;
    btn.setAttribute("aria-expanded", area.classList.contains("is-expanded") ? "true" : "false");
  }

  function expandOnOpen() {
    var modal = document.querySelector(
      '.quickview__modal.is-open, .quickview__modal[aria-hidden="false"]'
    );
    if (!modal) return; // not the quick shop drawer (e.g. cart / search)
    var area = modal.querySelector("[data-quickview-form-area]");
    var btn = modal.querySelector("[data-toggle-button]");
    if (!area) return;
    userToggled = false;
    if (btn) {
      if (!area.id) area.id = "qv-options-" + (modal.id || "x");
      btn.setAttribute("aria-controls", area.id);
      btn.setAttribute("aria-expanded", "true");
    }
    // Force expanded as the default on open, winning the race against the theme's
    // deferred toggleForm() collapse. Stop re-asserting once the user toggles, so a
    // deliberate manual collapse is respected.
    var force = function () {
      if (userToggled) return;
      if (!area.classList.contains("is-expanded")) area.classList.add("is-expanded");
      if (btn && !btn.classList.contains("is-active")) btn.classList.add("is-active");
    };
    force();
    var obs = new MutationObserver(force);
    obs.observe(area, { attributes: true, attributeFilter: ["class"] });
    setTimeout(function () {
      obs.disconnect();
    }, 850);
  }

  document.addEventListener("theme:scroll:lock", function () {
    setTimeout(expandOnOpen, 0);
  });

  // Mark a deliberate user toggle (so the open-guard stops fighting it) and keep
  // aria-expanded in sync with the collapsed/expanded state.
  document.addEventListener("click", function (e) {
    var btn = e.target.closest ? e.target.closest("[data-toggle-button]") : null;
    if (!btn) return;
    var modal = btn.closest(".quickview__modal");
    if (!modal) return;
    userToggled = true;
    setTimeout(function () {
      syncAria(modal);
    }, 0);
  });
})();

/* Dynamic edge fade for horizontal scrollers (trust bar + subcollection pills).
   Sets data-fade = none|right|left|both based on scroll position so the CSS mask fades
   only toward hidden content - so the trust bar fade disappears at the right end, and the
   pills get a fade instead of a scrollbar. Passive scroll + rAF throttle + ResizeObserver;
   idempotent (safe to re-run on shopify:section:load). */
(function () {
  var SELECTORS = ".collection__trust-bar, .subcollection-pills__track";
  var TOL = 2; // px tolerance for sub-pixel rounding on iOS/Android

  function fadeState(el) {
    var sl = el.scrollLeft;
    var sw = el.scrollWidth;
    var cw = el.clientWidth;
    if (sw <= cw + TOL) return "none"; // no overflow / fits
    var atStart = sl <= TOL;
    var atEnd = sl + cw >= sw - TOL;
    if (atStart) return "right";
    if (atEnd) return "left";
    return "both";
  }

  function initScroller(el) {
    if (el.dataset.fadeInit === "1") return;
    el.dataset.fadeInit = "1";
    var raf = null;
    var update = function () {
      el.dataset.fade = fadeState(el);
    };
    update();
    el.addEventListener(
      "scroll",
      function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          update();
        });
      },
      { passive: true }
    );
    if (window.ResizeObserver) {
      new ResizeObserver(update).observe(el);
    } else {
      window.addEventListener("resize", update);
    }
  }

  function initAll() {
    document.querySelectorAll(SELECTORS).forEach(initScroller);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
  document.addEventListener("shopify:section:load", initAll);
})();
